import {Dimensions, StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  containerStyles: {
    zIndex: 2,
    paddingVertical: 15,
    paddingHorizontal: 10,
    marginHorizontal: 15,
    borderRadius: 14,
    marginTop: 10,
  },
  scanHeader: {
    justifyContent: 'flex-start',
  },
  scanText: {
    flexGrow: 0.8,
  },
  image: {
    height: 75,
    width: 75,
  },
  highlightText: {
    borderRadius: 20,
    padding: 5,
    position: 'absolute',
    bottom: 0,
    alignSelf: 'center',
    zIndex: 3,
  },
  imageBox: {position: 'relative', marginLeft: 5},
  detailsContainer: {
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingHorizontal: 6,
  },
  textContainer: {
    alignItems: 'flex-start',
    // borderWidth: 1,
    marginLeft: 10,
    flex: 1,
  },
  unableToScanBox: {
    justifyContent: 'space-between',
    paddingLeft: 5,
    paddingRight: 10,
    marginTop: 5,
    marginBottom: 5,
    width: '100%',
  },

  itemNameText: {
    maxWidth: Dimensions.get('window').width - 120,
    textAlign: 'left',
    marginBottom: 10,
  },
  unableToScanText: {
    marginLeft: 5,
    textAlign: 'left',
    textDecorationLine: 'underline',
  },
  flexBox: {
    flex: 1,
  },
  accordian: {
    marginVertical: 10,
  },
  bottomAccordian: {
    padding: 10,
    marginTop: 5,
  },
  bottomCta: {
    // borderTopWidth: 0.5,
  },
  priceTagBox: {
    marginHorizontal: 20,
    marginTop: 5,
    justifyContent: 'center',
    paddingVertical: 10,
  },
  itemNameContainer: {
    flex: 1,
    flexGrow: 1,
    paddingVertical: 10,
    justifyContent: 'flex-start',
    alignContent: 'flex-start',
  },
  dividerSemiCircle: {marginBottom: 4, marginTop: 4},
  divider: {marginTop: 20},
  footerContaienr: {justifyContent: 'space-between', width: '100%'},
  barcodeBox: {gap: 5},
});
